// extracted by mini-css-extract-plugin
export default {"element":"EOn38NH_9G1tAGaFogVT"};